import { ServiceRequestsApi, ServiceRequestPostRequest } from 'cmp-client-api';
import type { HelpServiceInterface } from '@src/server';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import type { HelpRequestInterface, ServiceRequestInterface } from '@src/domain/types';

export class HelpService implements HelpServiceInterface {
  private readonly serviceRequestsApi: ServiceRequestsApi;

  private readonly serviceRequestMapper: MapperInterface<
    HelpRequestInterface,
    ServiceRequestPostRequest
  >;

  public constructor(
    serviceRequestMapper: MapperInterface<HelpRequestInterface, ServiceRequestPostRequest>,
    serviceRequestsApi: ServiceRequestsApi
  ) {
    this.serviceRequestMapper = serviceRequestMapper;
    this.serviceRequestsApi = serviceRequestsApi;
  }

  public async postRequest(body: HelpRequestInterface): Promise<ServiceRequestInterface> {
    const transformedRequest = this.serviceRequestMapper.transformToApiModel(body);
    const response = await this.serviceRequestsApi.createServiceRequest(
      undefined,
      transformedRequest
    );

    return {
      ...response.data.data,
      supportSystem: response.data.data.serviceNow,
    };
  }
}
